<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="11">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_keyword') ||
                  '车间名称 搜索...'
              "
              style="max-width: 400px"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot></slot>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_workshop_name') || '车间名称'"
            >
              <el-input
                v-model.trim="form.workshopName"
                clearable
                :placeholder="
                  $l('form_placeholder_workshop_name') || '请输入车间名称'
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_workshop_status') || '车间状态'"
            >
              <el-checkbox-group v-model="form.workshopStatusList">
                <el-checkbox label="Y">
                  {{ $l('table_label_status_valid') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('table_label_status_invalid') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  workshopName: '',
  workshopStatusList: ['Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
</style>
